module.exports = __webpack_public_path__ + "img/img2.ee93ed35.png";